import { useMatch, useResolvedPath } from 'react-router'

import type { NavItem } from '@/app/navigation'

/** Whether `item` matches the current URL (as a prefix). */
export function useNavItemActive(item: NavItem) {
  const { pathname } = useResolvedPath(item.to)
  return useMatch({ path: pathname, end: false }) !== null
}
